
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM5 3h2v2H5Zm0 4h2v2H5Zm0 6v-2h2v2Zm6 0H9v-2h2Zm0-4H9V7h2Zm0-4H9V3h2Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  